<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<h4 class="title">留言信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="姓名" >
							<el-input v-model="form.name" style="width: 30%;" readonly></el-input>
						</el-form-item>
						<el-form-item label="电话" >
							<el-input v-model="form.phone" style="width: 30%;" readonly></el-input>
						</el-form-item>
						<el-form-item label="邮箱" >
							<el-input v-model="form.email" style="width: 30%;" readonly></el-input>
						</el-form-item>
					</el-form>
					<div class="line"></div>
					<h4 class="title">商品参数</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
					<el-form-item :id="item.pid" :key="index" 
						
						v-for="(item,index) in form.inputList" :label="item.pName">
						<el-input v-model="item.par" style="width: 30%;" readonly></el-input>
					</el-form-item>
						<div class="line"></div>
						<el-form-item label="详细内容" style="margin-top: 40px;">
							<editor v-model="form.detail" :isClear="isClear" @change="change"></editor>
						</el-form-item>
						<!-- <el-form-item>
							<button type="primary" @click="onSubmit" class="submit">提交</button>
						</el-form-item> -->
					</el-form>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import E from "wangeditor";
	import Editor from '../../../components/tinymce.vue'
	export default {
		components: {
			Editor
		},
		data() {
			return {
				form: {
					name: '',
					phone: '',
					email: '',
					qq: '',
					name: '',
					detail: '',
					inputList:[]
				},
				isClear: false,
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: '请输入邮箱',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.getData()
		},
		mounted() {

		},
		methods: {
			getData(){
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/message/get',
					params: {
						uid: localStorage.getItem('uid'),
						id:this.$route.query.id
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.form.name = res.data.data.name
						this.form.phone = res.data.data.mobile
						this.form.email = res.data.data.email
						this.form.detail = res.data.data.content
						this.form.inputList = res.data.data.messageParList
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			change(val) {
				console.log(val)

			},
			onSubmit() {}

		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 30px;
	}

	/deep/ .el-input__inner {
		height: 30px !important;
	}

	/deep/ .el-form-item__label {
		width: 36px;
		height: 17px;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.3;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/message/Mupdate.vue